import React, { useState, useEffect } from 'react';
import Button from "components/CustomButtons/Button.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import { clone } from 'shared/utility';
import FileUploader from 'components/FileUploader/FileUploader';
import CustomInput from 'components/CustomInput/CustomInputValidate';
import { IconButton } from '@material-ui/core';

const FilesForm2 = (props) => {

    const data = props.data;

    if (!data) return null;

    const files = data.files ? data.files : [];

    const files_with_filename = files.filter(f => {
        if (f.filename) {
            return true;
        }
    })

    console.log('FilesForm2', props, data, files);

    return (
        <div className={props.disabled ? 'no-click gray-bg' : ''}>
            <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                    <h2>Files</h2>
                    {!props.disabled && <Button color="primary" onClick={() => {
                        const newData = clone(data);
                        console.log('nd', newData)
                        if (!newData.files) newData.files = [];
                        newData.files.push({
                            filename: '',
                            description: ''
                        })

                        props.updateDataObj('files', newData.files);
                    }}>
                        ADD FILE
                    </Button>}
                    <hr />
                    {<div className="mt-20 mb-20">
                        {files_with_filename.length} File(s)
                    </div>}
                    <GridContainer>
                
                    {
                        files.map((f,i) => {
                            return <GridItem xs={12} sm={12} md={3} key={`${i}-fileform`}>
                            <div className="mr-20 mt-20">
                                {!f.filename && <div style={{float:'right'}}><IconButton
                                onClick={() => {
                                    const newData = clone(data);
                                        if (!newData.files) newData.files = [];
                                        newData.files = newData.files.filter((ff,ii) => {
                                            if (ii === i) return false;
                                            return true;
                                        })
                                        props.updateDataObj('files', newData.files);
                                }}
                                ><i className="fa fa-trash red-text" style={{marginRight:20,fontSize:14}}></i></IconButton></div>}
                                <div className="boxed mr-20 mt-20">    
                                    <FileUploader 
                                        title={`File ${i+1}`}
                                        update={(val) => {
                                            const newData = clone(data);
                                            if (!newData.files) newData.files = [];
                                            newData.files = newData.files.map((ff,ii) => {
                                                if (ii === i) {
                                                    ff.filename = val;
                                                    return ff;
                                                }
                                                return ff;
                                            })
                                            props.updateDataObj('files', newData.files);
                                        }}
                                        remove={() => {
                                            const newData = clone(data);
                                            if (!newData.files) newData.files = [];
                                            newData.files = newData.files.filter((ff,ii) => {
                                                if (ii === i) return false;
                                                return true;
                                            })
                                            props.updateDataObj('files', newData.files);
                                        }}
                                        the_filename={f.filename}
                                        type="crm"
                                        accept="application/pdf,image/*"
                                        // fileType="application/pdf"
                                        disabled={props.disabled ? true : false}
                                    />

                                    <CustomInput 
                                        value={f.description}
                                        onChange={(e) => {
                                            const newData = clone(data);
                                            if (!newData.files) newData.files = [];
                                            newData.files = newData.files.map((ff,ii) => {
                                                if (ii === i) {
                                                    ff.description = e.target.value;
                                                    return ff;
                                                }
                                                return ff;
                                            })
                                            props.updateDataObj('files', newData.files);
                                        }}
                                        label="Description"
                                        disabled={props.disabled ? true : false}
                                    />
                                </div>
                            </div>
                        </GridItem>
                        })
                    }
                    </GridContainer>
                </GridItem>
            </GridContainer>
        </div>
    )

}

export default FilesForm2;